import moment from 'moment-timezone';

const timezone = 'America/Toronto';
const sections = {
    free: {
        today: { period: 'today', free: '1', category: '' },
        weekend: { period: 'weekend', free: '1', category: '' },
        family: { period: 'next30Days', free: '1', category: 'famille' },
        exhibitions: { period: 'next30Days', free: '1', category: 'expositions' },
        shows: { period: 'next30Days', free: '1', category: 'musique;theatre;comedie;soirees' },
    },
    family: {
        today: { period: 'today', free: '0', category: 'famille' },
        weekend: { period: 'weekend', free: '0', category: 'famille' },
        free: { period: 'next30Days', free: '1', category: 'famille' },
        upcoming: { period: 'thisWeek', free: '0', category: 'famille' },
    },
};

export function getActivityPeriodRange(period, now = new Date()) {
    const today = moment.tz(now, timezone).startOf('day');
    let start = today.clone();
    let end = today.clone();
    if (period === 'weekend') {
        // On Saturday/Sunday, keep the current weekend rather than skipping it.
        start.isoWeekday(5);
        end = start.clone().isoWeekday(7);
    } else if (period === 'thisWeek') {
        start.startOf('isoWeek');
        end.endOf('isoWeek');
    } else if (period === 'next30Days') {
        end.add(29, 'days');
    } else if (period !== 'today') return null;
    return { start: start.format('YYYY-MM-DD'), end: end.format('YYYY-MM-DD') };
}

export function getActivityBrowseUrl(page, section, now = new Date()) {
    const filter = sections[page][section];
    const period = filter.period === 'today' ? getActivityPeriodRange('today', now).start : filter.period;
    const params = new URLSearchParams({
        cat: filter.category, f: filter.free, p: period, t: 'Toute heure',
        q: '', c: 'Québec', v: '', lat: '', long: '',
    });
    return `/?${params}#search`;
}

// Previews and full-result links share one definition of each section's filters.
export function getActivityPreviewQuery(page, section, now = new Date()) {
    const filter = sections[page][section];
    const range = getActivityPeriodRange(filter.period, now);
    const params = new URLSearchParams({
        date: range.start, endDate: range.end, timezone, city: 'Québec',
        category: filter.category, distinctPrograms: '1', limit: '12',
    });
    if (filter.free === '1') params.set('free', '1');
    return params.toString();
}
